import { useQuery } from "@apollo/client";

import { GET_NEWS_DETAIL } from "./newsAndMedia.gql";

export const useNewsDetail = (props) => {
  const { id } = props;

  const { loading, data } = useQuery(GET_NEWS_DETAIL, {
    variables: {
      eq: id,
    },
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-first",
  });

  const NewsDetails = data?.mpNewsPosts?.items[0];

  return {
    loading,
    NewsDetails,
  };
};
